
import layout from '@/layout'

const asyncRoutes = [
  {
    path: '/permission',
    redirect: '/permission/user',
    hidden: true
  },

  {
    path: '/permission',
    component: layout,
    children: [
      {
        path: 'page',
        name: 'permission-page',
        component: () => import('@/views/permission/page.vue'),
        meta: {
          icon: 's-tools',
          title: '管理系统',
          roles: ['superadmin']
        }
      }
    ]
  },

  {
    path: '/permission',
    component: layout,
    children: [
      {
        path: 'user',
        name: 'permission-user',
        component: () => import('@/views/permission/user.vue'),
        meta: {
          icon: 'menu',
          title: '权限浏览',
          roles: ['admin', 'superadmin', 'user']
        }
      }
    ],
    hidden: true,
  },

  {
    path: '/permission',
    component: layout,
    children: [
      {
        path: 'super',
        name: 'permission-super',
        component: () => import('@/views/permission/super.vue'),
        meta: {
          icon: 'user-solid',
          title: '超级管理',
          roles: ['superadmin']
        }
      }
    ]
  },

 

  {
    path: '/sjimg',
    component: layout,
    children: [
      {
        path: '',
        name: 'sjimg',
        meta: {
          icon: 'location',
          title: '试卷图像',
          
        },
        component: () => import('@/views/sjimg')
      }
    ],
    hidden: true
  },




  {
    path: '/cjxmmain',
    component: layout,
    children: [
      {
        path: '',
        name: 'cjxmmain',
        meta: {
          icon: 'location',
          title: '项目成绩',
          //roles: ['admin', 'superadmin']
        },
        component: () => import('@/views/schoolcj/xmmain.vue')
      }
    ],
    hidden: true
  },


  {
    path: '/qscore',
    component: layout,
    children: [
      {
        path: '',
        name: 'qscore',
        meta: {
          icon: 'location',
          title: 'qscore',
         // roles: ['admin', 'superadmin']
        },
        component: () => import('@/views/page1/qscore.vue')
      }
    ],
    hidden: true
  },

  {
    path: '/yuejuan',
    component: layout,
    children: [
      {
        path: '',
        name: 'yuejuan',
        meta: {
          icon: 'edit',
          title: '阅卷相关',
          keepAlive: true,
          roles: ['admin', 'superadmin', 'teacher']
        },
        component: () => import('@/views/yuejuan')
      }
    ]
  },

  {
    path: '/yjmain',
    component: layout,
    children: [
      {
        path: '',
        name: 'yjmain',
        meta: {
          icon: 'picture',
          title: '阅卷',
          roles: ['admin', 'superadmin', 'teacher']
        },
        component: () => import('@/views/yjmain')
      }
    ],
    hidden: true
    
  },
  {
    path: '/dankejindu',
    component: layout,
    children: [
      {
        path: '',
        name: 'dankejindu',
        meta: {
          icon: 'picture',
          title: '单科进度',
          roles: ['admin', 'superadmin', 'teacher']
        },
        component: () => import('@/views/jindu/dankejindu.vue')
      }
    ],
    hidden: true
    
  },

  {
    path: '/ffguize',
    component: layout,
    children: [
      {
        path: '',
        name: 'ffguize',
        meta: {
          icon: 'edit',
          title: '赋分规则',
          keepAlive: true,
          roles: ['admin', 'superadmin']
        },
        component: () => import('@/views/ffguize')
      }
    ]
  },

  {
    path: '/ffmain',
    component: layout,
    children: [
      {
        path: '',
        name: 'ffmain',
        meta: {
          icon: 'edit',
          title: '单科赋分',
          keepAlive: true,
          roles: ['admin', 'superadmin']
        },
        component: () => import('@/views/ffmain')
      }
    ]
  },

  {
    path: '/schoolcj',
    component: layout,
    children: [
      {
        path: '',
        name: 'schoolcj',
        meta: {
          icon: 'location',
          title: '学校报表',
          roles: ['admin']
        },
        component: () => import('@/views/schoolcj/xmsel.vue')
      }
    ]
  },

  {
    path: '/uploadsc',
    component: layout,
    meta: { hideLink: true },
    children: [
      {
        path: '',
        name: 'upload',
        meta: {
          hideLink: true,
          icon: 'edit',
          title: '上传统计',
          keepAlive: true,
          roles: ['admin', 'schoolman']
        },
        component: () => import('@/views/schoolman/uploadsc.vue')
      }
    ],
    hidden: true
  },
  {
    path: '/yuejuansc',
    component: layout,
    meta: { hideLink: true },
    children: [
      {
        path: '',
        name: 'upload',
        meta: {
          hideLink: true,
          icon: 'edit',
          title: '阅卷统计',
          keepAlive: true,
          roles: ['admin', 'schoolman']
        },
        component: () => import('@/views/schoolman/yuejuansc.vue')
      }
    ],
    hidden: true
  },

  {
    path: '/scoresc',
    component: layout,
    meta: { hideLink: true },
    children: [
      {
        path: '',
        name: 'upload',
        meta: {
          hideLink: true,
          icon: 'edit',
          title: '成绩报表',
          keepAlive: true,
          roles: ['admin', 'schoolman']
        },
        component: () => import('@/views/schoolman/scoresc.vue')
      }
    ],
    hidden: true
  },
  {
    path: '/zfbaobiao',
    component: layout,
    meta: { hideLink: true },
    children: [
      {
        path: '',
        name: 'upload',
        meta: {
          hideLink: true,
          icon: 'edit',
          title: '成绩报表',
          keepAlive: true,
          roles: ['admin', 'schoolman']
        },
        component: () => import('@/views/schoolman/zfbaobiao.vue')
      }
    ],
    hidden: true
  },

  {
    path: '/datasc',
    component: layout,
    meta: { hideLink: true },
    children: [
      {
        path: '',
        name: 'upload',
        meta: {
          hideLink: true,
          icon: 'edit',
          title: '成绩报表',
          keepAlive: true,
          roles: ['admin', 'schoolman']
        },
        component: () => import('@/views/schoolman/datasc.vue')
      }
    ],
    hidden: true
  },


  {
    path: '/jinduxq',
    component: layout,
    children: [
      {
        path: '',
        name: 'upload',
        meta: {
          icon: 'edit',
          title: '进度详情',
          keepAlive: true,
          roles: ['adminxx', 'jinduxq']
        },
        component: () => import('@/views/jinduxq/xmlist.vue')
      }
    ]
  },

  {
    path: '/jinduxqxm',
    component: layout,
    children: [
      {
        path: '',
        name: 'upload',
        meta: {
          icon: 'edit',
          title: '项目科目',
          keepAlive: true,
          roles: ['adminxx', 'jinduxq']
        },
        component: () => import('@/views/jinduxq/xmkemu.vue')
      }
    ]
  },
  {
    path: '/examman',
    component: layout,
    children: [
      {
        path: '',
        name: 'examman',
        meta: {
          icon: 'edit',
          title: '考试管理',
          keepAlive: true,
          roles: ['admin']
        },
        component: () => import('@/views/examman/examsc.vue')
      }
    ]
  },

  {
    path: '/scorexmain',
    component: layout,
    children: [
      {
        path: '',
        name: 'scorexmain',
        meta: {
          icon: 'edit',
          title: '成绩管理',
          keepAlive: true,
          roles: ['admin']
        },
        component: () => import('@/views/examman/scorexmain.vue')
      }
    ]
  },
  {
    path: '/scorexsxfen',
    component: layout,
    children: [
      {
        path: '',
        name: 'scorexsxfen',
        meta: {
          icon: 'edit',
          title: '成绩管理',
          keepAlive: true,
          roles: ['admin']
        },
        component: () => import('@/views/examman/scorexsxfen.vue')
      }
    ],
    hidden: true,
  },

  {
    path: '/schoolman',
    component: layout,
    children: [
      {
        path: '',
        name: 'schoolmani',
        meta: {
          icon: 'edit',
          title: '学校管理',
          keepAlive: true,
          roles: ['admin','schoolman']
        },
        component: () => import('@/views/schoolman/index.vue')
      }
    ]
  },

  {
    path: '/jinduxqkmxq',
    component: layout,
    children: [
      {
        path: '',
        name: 'upload',
        meta: {
          icon: 'edit',
          title: '科目详情',
          keepAlive: true,
          roles: ['adminxx', 'jinduxq']
        },
        component: () => import('@/views/jinduxq/kemudetail.vue')
      }
    ]
  },

  


  { path: '*', hidden: true, redirect: '/404' }
]

export default asyncRoutes
